module.exports = __webpack_public_path__ + "img/kids.33b95cef.jpg";